<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>售后服务</el-breadcrumb-item>
      <el-breadcrumb-item>意见反馈</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first" disabled="disabled">
        <!-- 查询用户 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.keyword" @keyup.enter.native="clicksearch" placeholder="请输入意见" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询用户 end -->

        <el-table :data="dataList" border stripe >
          <el-table-column prop="Name" label="会员姓名" width="100px"></el-table-column>
          <el-table-column prop="Suggestion" label="意见"></el-table-column>
          <el-table-column prop="Createtime" label="发起时间" width="170px"></el-table-column>
          <el-table-column prop="Replystatus" label="处理状态" width="100px"></el-table-column>
          <el-table-column prop="Adminname" label="处理人员" width="100px"></el-table-column>
          <el-table-column prop="Updatetime" label="处理时间" width="170px"></el-table-column>
          <el-table-column prop="" fixed="right" label="操作" width="100px">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goFeedbackReply(scope.row)">处理</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <el-tab-pane label="处理" name="second" disabled="disabled">
        <FeedbackReply ref="SubVuesecond" v-on:triggerFunc="BackToFirst"></FeedbackReply>
      </el-tab-pane>

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import FeedbackReply from '@/componentsSubVue/FeedbackReply.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    FeedbackReply
  },
  name: 'MyFeedback',
  data () {
    return {
      activeName: 'first',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      // 查询客户
      keywords: {
        keyword: ''
      }
    }
  },
  mounted () {
    this.apiFeedbacknum()
    this.apiFeedbacklist()
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiFeedbacklist()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiFeedbacknum()
      this.apiFeedbacklist()
    },
    goFeedbackReply (row) {
      this.activeName = 'second'
      this.$refs.SubVuesecond.LoadData({ name: '', params: { feedbackid: row.Id, suggestion: row.Suggestion, reply: row.Reply } })
    },
    apiFeedbacklist: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        keyword: that.keywords.keyword
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Feedbacklist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiFeedbacknum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        keyword: that.keywords.keyword
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Feedbacknum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}
</style>
